import { BlastworksClientEvent, ClientController } from 'client-controller';
import { PopRequestSpinState } from 'state-machine/states/pop-request-spin-state';

/**
 * Social request spin state, sends spin result message
 *
 * @class SocialRequestSpinState
 * @typedef {SocialRequestSpinState}
 * @extends {PYLSlingoRequestSpinState}
 */
export class SocialRequestSpinState extends PopRequestSpinState {
  /**
   * Send complete message
   *
   * @public
   * @override
   */
  public complete(): void {
    ClientController.getInstance().raiseEvent(BlastworksClientEvent.SPIN_RESULT);
    super.complete();
  }
}
